<template>
	<section class="section">
		<div class="row">
			<div class="col-lg-3">
				<filter-sidebar v-bind:filters="filters" v-bind:title="title"></filter-sidebar>
			</div>

			<div class="col-lg-9" v-if="listing.length">
                <div class="featured" v-if="((featuredvideourl) || (featuredctalink) || (featureddescription))">
                    <div class="card summary-item featured-wrapper col-12">
                        <a class="card-content-wrapper card-link-wrapper">
                            <div class="card-body">
                                <a v-if="featuredvideourl" v-bind:href="featuredvideourl" class="thumb-video open-self video js-video">
                                    <div class="card-media" role="img" v-bind:aria-label="featuredtitle" v-bind:style="{ 'background-image': 'url(' + optimizedImage + ')' }">
                                        <span class="play-btn"></span>
                                        <span class="sr-only">iframe video</span>
                                    </div>
                                </a>
                                <div class="card-media" role="img" v-if="!featuredvideourl" v-bind:aria-label="featuredtitle" v-bind:style="{ 'background-image': 'url(' + optimizedImage + ')' }"></div>
                                <div class="card-body-content-wrapper">
                                    <h2 class="card-title">{{ featuredtitle }}</h2>
                                    <div class="card-description">{{ featureddescription }}</div>
                                </div>
                                <div class="card-cta">
                                    <div class="link m-0 open-self video js-video" v-if="((featuredvideourl) && !(featuredctalink))"
                                        v-bind:href="featuredvideourl">{{ featuredVideoCTALabel }}</div>
                                    <a class="link m-0" v-if="featuredctalink"
                                        v-bind:href="featuredctalink"
                                        :target="featuredctalink == '' ? null : '_blank'">{{ featuredctatext }}</a>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
				<div class="cards--pull-up cards--grid cards d-flex d-md-block">
					<div class="cards-container">
						<summary-item v-bind:uselistinglayout="uselistinglayout" v-for="(item, index) in listing" v-bind:item="item" v-bind:key="item.DetailID"></summary-item>
					</div>
				</div>

				<pagination></pagination>
			</div>

			<div class="cards-no-results col-lg-9" v-if="listing.length < 1">
                <div class="content-wrapper">
                    <h2>No Results</h2>
                    <p>Sorry, there are no results matching your filter options.</p>
                    <a href="" v-on:click="resetFilters">Clear All Filters</a>
                </div>
			</div>
		</div>
	</section>
</template>

<script>
	    import {mapState, mapActions, mapMutations} from 'vuex';
	    import ClassroomPagination from '../../custom/components/listing/classroom-pagination-dropdown';
        import ClassroomSummaryItem from '../../custom/components/listing/classroom-summary-item';
        import ClassroomFilterSidebar from '../../custom/components/listing/classroom-filter-sidebar';
        import resourcefilter from '../../custom-apps/filters/resource-filter';
        import imageOptimizer from '../../common/utils/image-optimizer';
        import Util from '../../../js/common/utils/ui';
        import * as CONST from '../../../js/common/utils/constants';

	export default {
            props: ['filterid', 'filtertype', 'result', 'resource', 'title', 'uselistinglayout', 'featuredtitle', 'featureddescription', 'featuredimage', 'featuredvideourl', 'featuredctalink', 'featuredctatext'],
		data: function () {
			return {
                filters: {},
            }
        },
		computed: mapState({
            loading: state => state.listing.loading,
            listing: state => state.listing.listing,
            pagination: state => state.listing.pagination,
            optimizedImage: function() {
                let html = document.querySelector('html');

                if (html.classList.contains('webp')){
                    if (this.featuredimage !== null && this.featuredimage !== "") {
                        return imageOptimizer.getOptimizedImageUrl(this.featuredimage, 'webp');
                    }
                    else {
                        return '/content/images/content-placeholder.webp';
                    }
                }
                else {
                    if (this.featuredimage !== null && this.featuredimage !== "") {
                        return imageOptimizer.getSanitizeMediaUrl(this.featuredimage);
                    }
                    else {
                        return '/content/images/content-placeholder.png';
                    }
                }
            },
            featuredVideoCTALabel: function() {
                if(this.featuredctatext) {
                    return thus.featuredctatext;
                } else {
                    return 'Watch Video';
                }
            }
    }),
		components: {
            pagination: ClassroomPagination,
            'summary-item': ClassroomSummaryItem,
            'filter-sidebar': ClassroomFilterSidebar
    },
		mounted: function () {
            let _this = this;

            // take props and send to vuex store
            this.setInitData(this.result);
            this.setResource(this.resource);

            let anchor = document.querySelector('#filter-app');
            let header = document.getElementsByClassName('header')[0];

            // import correct filters for this view based on prop value
            if (this.filtertype === 'resourcefilter') {
                this.filters = resourcefilter;
            }

            // after any api calls, scroll to the top of the list
            this.$store.subscribeAction((action, state) => {
                if (action.type === 'listing/setFilter') {
                    anchor.scrollIntoView(true);
                    location.reload();
                }
            })

            // if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'listing/updateSpecification') {
                    this.setFilter();
                }
            });
        },
		methods: {
            ...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', {setInitData: 'setInitData' }),
			...mapMutations('listing', {setResource: 'setResource' }),
			...mapMutations('listing', { resetSpecification: 'resetSpecification' }),
            resetFilters() {
		        this.resetSpecification();
            },
            checkforCopyLink: function(codeName, url) {
                if(codeName === 'Featured' && url !== '') {
                    event.preventDefault();
                    navigator.clipboard.writeText(url).then(function() {
                        console.log('Copied!');
                    });
                }
            }
    },
}
</script>